import JobApplicationSection from './JobApplicationSection.component';

export default JobApplicationSection;